import {type ComponentProps, type ReactNode} from 'react';

import {AppButton} from '@/components/Button';
import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxInfoBoxActionButtonProps extends ComponentProps<typeof AppButton> {
    label: string;
    icon?: ReactNode;
    alt?: string;
}

const AutoDeliveryDcxInfoBoxActionButton = ({
    label,
    icon,
    alt,
    className,
    ...rest
}: AutoDeliveryDcxInfoBoxActionButtonProps) => {
    return (
        <AppButton
            secondary
            light
            className={twx('m-0 w-full self-start @2xl/inline-notification:w-auto', icon && 'py-2', className)}
            aria-label={alt}
            {...rest}
        >
            <span className='flex flex-row items-center justify-center gap-3'>
                {icon}
                {label}
            </span>
        </AppButton>
    );
};

export default AutoDeliveryDcxInfoBoxActionButton;
